/**
 * SxaAssessmentRootTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

// Sxa Components
import SxaHeaderTile from './SxaHeaderTile';
import SxaAssessmentLandscapeTile from './SxaAssessmentLandscapeTile';
import SxaFooterTile from './SxaFooterTile';

import axios from "axios";

// custom font styles
const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            'Open Sans, sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
});

class SxaAssessmentRootTile extends React.Component {
    constructor(props) {
        super(props);

        console.log("Assessment Root init; ass = " + props.ass.oid +
            "; current Q = " + props.ass.currentQuestion.oid);
        document.body.style.backgroundColor = '#e6eaee';

        // Assign A ref to state for refresh
        this.state = {
            ass: props.ass
        };
    }

    componentDidMount() {
        //console.log("Assessment_Root.componentDidMount()");
        document.body.style.backgroundColor = '#e6eaee';

        // Signal an artificial score change to get new A to update Results panel
        // FIXME - only if transitioning from portrait to landscape - set transition flag? TBD
        this.signalScoreChange();

        // Call down to landscape tile
        if (this.land) {
            this.land.signalAChange(this.state.ass);
        }
    }

    // Callback function used by child to signal A Start
    signalStart = () => {
        // Pre-Condition:
        // (A) progress state is NOT_STARTED - defensive

        //console.log("Assessment_Root.signalStart()");

        var url = 'api/assessment/start';
        axios.get(url)
            .then(response => {
                // Handle A-state change - callback function
                console.log("Assessment START server call completed");

                var newA = response.data;
                //console.log(newA);
                this.setState( state => ({ ass: newA }) );

                console.log("setState() call completed with new A");

                // Signal new A state on App (real root)
                // so that e.g. switch to portrait mode picks up the correct A state (Started...)
                this.props.signalAChange(newA);
            })
            .catch(err => console.error(err))
    }

    // Callback function used by child to signal Q-score change
    signalScoreChange = () => {
        //console.log("Assessment_Root.signalScoreChange()");

        // Update the Assessment results tile to reflect the new score
        // Get the updated A state
        var url = 'api/assessment';
        axios.get(url)
            .then(response => {
                //console.log(response.data);
                this.setState({ ass: response.data });

                // Call down to landscape tile
                this.land.updateResults(this.state.ass);
            })
            .catch(error => {
                console.error(error)
            })
    }

    // Callback function used by children to signal Q change (e.g. nav back or next, PA or D select)
    signalQChange = (q) => {
        // Debug trace
        //console.log("A-Root.signalQChange(); new Q = " + q.oid +
        //    "; PA id = " + q.paId +
        //    "; D id = " + q.dId
        //);

        // Update the root A
        var currA = this.state.ass;
        currA.currentQuestion = q;
        currA.currentProcessAreaID = q.paId;
        currA.currentDimensionID = q.dId;

        this.setState({ ass: currA} );

        // Signal to App so portrait mode picks up q change
        this.props.signalAChange(currA);
    }

    render() {
        return(
            <MuiThemeProvider theme={theme}>
            <React.Fragment>
                { this.state.ass ? (
                    <div>
                        <SxaHeaderTile ass={this.state.ass} />
                        <SxaAssessmentLandscapeTile ass={this.state.ass}
                                                    signalStart={this.signalStart}
                                                    signalScoreChange={this.signalScoreChange}
                                                    signalQChange={this.signalQChange}
                                                    innerRef={(land) => {
                                                        this.land = land;
                                                    }}
                        />
                        <SxaFooterTile ass={this.state.ass} />
                    </div>
                ) : "No Assessment found"}
            </React.Fragment>
            </MuiThemeProvider>
        )
    }
}

export default SxaAssessmentRootTile;